import * as React from 'react';
import {AriaLabelOrLabelledby} from '@volkswagen-onehub/components-core/dist/helpers/types';

export interface MediaGalleryState {
    readonly activeIndex: number;
    readonly lastIndex: number;
    readonly animate: boolean;

    readonly dragStartPosition: number;
    readonly dragStartTime: number;
    readonly dragEnabled: boolean;

    readonly slidePosition: number;
    readonly slideLength: number;
    readonly slideKeys: (React.Key | null)[];
}

export type UseMediaGalleryContextValueProps = {
    index: number;
    children:
        | React.ReactElement<AriaLabelOrLabelledby & {key: React.Key}>
        | React.ReactElement<AriaLabelOrLabelledby & {key: React.Key}>[];

    childrenLength: number;
    handleChange: (i: number) => void;
};
export type MediaGalleryAction =
    | {type: 'SLIDE_CHANGE'; index: number; animate: boolean}
    | {type: 'DRAG_START'; position: number}
    | {type: 'DRAG_MOVE'; index: number}
    | {type: 'SET_SLIDE_LENGTH'; length: number}
    | {type: 'SET_SLIDE_KEYS'; slideKeys: (React.Key | null)[]};

export const useMediaGalleryContextValue = ({
    index,
    children,
    childrenLength,
    handleChange
}: UseMediaGalleryContextValueProps) =>
    React.useMemo(() => {
        const mediaGalleryState: MediaGalleryState = {
            // for now we just add the values needed for the lentils
            activeIndex: index,
            slideLength: childrenLength,
            slideKeys: React.Children.toArray(children)
                .filter(React.isValidElement)
                .map(child => child.key),
            // the following values are not maintained, but they are not needed for the lentils
            lastIndex: NaN,
            animate: false,
            dragStartPosition: NaN,
            dragStartTime: NaN,
            dragEnabled: false,
            slidePosition: NaN
        };

        const dispatch: React.Dispatch<MediaGalleryAction> = action => {
            // we currently only handle the lentils' SLIDE_CHANGE action
            if (action.type === 'SLIDE_CHANGE') {
                handleChange(action.index);
            }
        };

        return {
            state: mediaGalleryState,
            dispatch,
            getState: () => mediaGalleryState
        };
    }, [children, childrenLength, handleChange, index]);
